import { render, staticRenderFns } from "./RotateLeftIcon.vue?vue&type=template&id=60154b70&"
import script from "./RotateLeftIcon.vue?vue&type=script&lang=js&"
export * from "./RotateLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports